import type { LanguageTokens } from 'i18n'
import type { Settings } from 'react-slick'
import { Cdn } from 'utils/assets'

export const settings: Settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  draggable: false
}

const firstAccessImage1 = Cdn.getImageUrl('forest/onboarding-forest-step-1.png')
export const firstAccessImage2 = Cdn.getImageUrl(
  'forest/onboarding-first-tree.webp'
)
const firstAccessImage3 = Cdn.getImageUrl('forest/onboarding-forest-step-3.png')
const firstAccessImage4 = Cdn.getImageUrl('forest/onboarding-forest-step-4.png')

export const firstAcessData = [
  {
    image: firstAccessImage1,
    title: 'A floresta precisa de você!',
    description:
      'Infelizmente, uma área da floresta foi desmatada, deixando animais desabrigados e a natureza em perigo. Agora, sua missão é ajudar a replantar árvores e criar um novo lar para eles. Junte-se a nós nessa importante tarefa!'
  },
  {
    image: firstAccessImage2,
    title: 'O poder da sua leitura!',
    description:
      'À medida que você lê alguns livros, você conquista moedas, que podem ser usadas para adquirir sementes e iniciar o reflorestamento. Quanto mais você lê, mais moedas ganha e mais árvores podem ser plantadas!'
  },
  {
    image: firstAccessImage3,
    title: 'Não deixe a floresta secar!',
    description:
      'Além das sementes, a floresta precisa de gotas para prosperar. Para garantir seu crescimento saudável, lembre-se de manter o contador de leitura em equilíbrio. A cada dia sem leitura, o nível de gotas diminui, e é responsabilidade sua mantê-lo abastecido para que a floresta floresça.'
  },
  {
    image: firstAccessImage4,
    title: 'Hora de começar essa jornada!',
    description:
      'Com algumas moedas em mãos, vamos iniciar o plantio da nossa primeira árvore. Lembre-se de que seu progresso será recompensado com moedas e gotas à medida que você se envolve mais com a leitura. Contamos com você para salvar a floresta e criar um ambiente harmonioso!'
  }
] as {
  image: string
  title: LanguageTokens
  description: LanguageTokens
}[]
